export default __webpack_public_path__ + "static/media/supplier-1.616348f6.png";